import { useTheme } from "../../contexts/ThemeContext"
import { Toaster as Sonner, toast } from "sonner"
import { useMediaQuery } from "../../lib/useMediaQuery"
import { useIsPublicRoute } from "../../lib/publicRoutes"

const Toaster = ({
  ...props
}) => {
  // Il tema arriva dal ThemeContext dell'app: prima veniva da next-themes,
  // che non ha mai avuto un provider montato e quindi seguiva l'OS.
  const { theme } = useTheme()
  // Landing, login e policy restano scure anche col tema chiaro attivo. I
  // toast si montano su document.body, quindi fuori dal loro contenitore:
  // senza questo, un "sessione scaduta" uscirebbe chiaro su una pagina nera.
  const isPublicRoute = useIsPublicRoute()
  const effectiveTheme = isPublicRoute ? "dark" : theme
  // Su desktop l'angolo in alto a destra e' occupato dal menu utente: un toast
  // li' sopra (sonner usa z-index 999999999) ne intercetta i click e, appena il
  // puntatore lo sfiora, mette in pausa il proprio timer di chiusura. In basso a
  // destra il desktop e' libero; su mobile restiamo in alto per non finire sotto
  // la bottom nav flottante.
  const isDesktop = useMediaQuery("(min-width: 768px)")

  return (
    <Sonner
      theme={effectiveTheme}
      className={`toaster group${isPublicRoute ? " theme-dark-scope" : ""}`}
      position={isDesktop ? "bottom-right" : "top-right"}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          // Sonner colora il pulsante con variabili proprie legate al tema di
          // sistema: senza questo override diventerebbe un cerchio bianco su una
          // UI sempre scura.
          closeButton:
            "group-[.toast]:!bg-card group-[.toast]:!text-foreground group-[.toast]:!border-border group-[.toast]:hover:!bg-muted",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
